import {textFilterParamsValues} from "../../reactTableController";

export const defaultSortModel = [
    {
        colId: 'groupName',
        sort: 'asc',
        sortIndex: 0
    }
];
export const reactGroupCols = function ( translate, filterFormatter) {
    return [ {
        field: "groupName",
        headerName: translate.instant('GROUP_NAME'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "description",
        headerName: translate.instant('DESCRIPTION'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "membersCount",
        headerName: translate.instant('NUM_OF_ACCOUNTS'),
        filter: false,
        sortable: true
    },{
        field: "lastUpdate",
        headerName: translate.instant('LAST_UPDATE'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateTime')( params.data.lastUpdate) : "";
        }
    }];
}
